<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  >
    <v-snackbar
      v-model="snackbar"
      xs12
      multi-line
      :timeout="timeout"
      top
      color="orange"
    >
      {{ alertmessage }}
      <v-btn
        color="white"
        text
        @click="closealert"
      >
        Close
      </v-btn>
    </v-snackbar>
    <sequential-entrance from-top>
      <v-row>
        <v-col
          cols="12"
          md="6"
        >
          <base-material-card
            color="primary"
            icon="mdi-check"
            inline
          >
            <template v-slot:after-heading>
              <div class="display-2 font-weight-light">
                Postal Package Check In
              </div>
            </template>
            <v-row>
              <v-col
                cols="12"
              >
                <v-text-field
                  v-model="name"
                  :rules="nameRules"
                  label="Checked By"
                  readonly
                  outlined
                  required
                />
                <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation
                >
                  <v-text-field
                    v-model="package_tracking_number"
                    :rules="package_tracking_rules"
                    :counter="22"
                    label="Tracking Number"
                    outlined
                    required
                  />
                  <v-btn
                    color="error"
                    class="mr-4"
                    @click="reset"
                  >
                    Reset Form
                  </v-btn>
                  <v-btn
                    color="warning"
                    :disabled="!valid"
                    @click="findpackage"
                  >
                    Validate Package
                  </v-btn>
                </v-form>
              </v-col>
            </v-row>
          </base-material-card>
        </v-col>
        <v-col
          cols="12"
          md="6"
        >
          <v-card
            v-if="shipmentDetail"
            :loading="loading"
            class="mx-auto"
            max-width="374"
          >
            <template slot="progress">
              <v-progress-linear
                color="deep-purple"
                height="10"
                indeterminate
              />
            </template>

            <v-img
              height="250"
              src="/img/uspslogo.png"
            />

            <v-card-title>USPS Shipment Details</v-card-title>

            <v-card-text>
              <div class="my-4 text-subtitle-1">
                Shipment Date: {{ shipmentDetail.ship_date }}
              </div>
              <div>
                Delivery Date: {{ shipmentDetail.actual_delivery_date }}
              </div>
              <div>
                Tracking Number: {{ shipmentDetail.tracking_number }}
              </div>
            </v-card-text>

            <v-divider class="mx-4" />

            <v-card-title>Check In Details </v-card-title>

            <v-card-text class="font-weight-black">
              {{ checkinInstructions }}
            </v-card-text>

            <v-card-actions>
              <v-btn
                color="cyan lighten-2"
                @click="CheckInPackage"
              >
                Check Shipment In
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </sequential-entrance>
  </v-container>
</template>

<script>
  import moment from 'moment'
  import { utcToZonedTime, format, zonedTimeToUtc } from 'date-fns-tz'
  import { jsPDF } from 'jspdf'
  const axios = require('axios')
  var numeral = require('numeral')
  var jrQrcode = require('jr-qrcode')

  export default {
    name: 'Depositusersbysite',
    props: ['id'],
    data: () => ({
      dialog: false,
      select: null,
      items: [
        'Item 1',
        'Item 2',
        'Item 3',
        'Item 4',
      ],
      checkbox: false,
      package_tracking_number: '',
      packagedetail: '',
      selected: [],
      group: '',
      loading: false,
      sitedetails: '',
      snackbar: false,
      unit_id: '',
      timeout: 7000,
      singleSelect: false,
      valid: true,
      search: '',
      alertmessage: '',
      baglist: [],
      expanded_bags: [],
      singleExpand: true,
      name: '',
      nameRules: [
        v => !!v || 'Name is required',
      ],
      package_tracking_rules: [
        v => !!v || 'Tracking Number is required',
        v => /^[0-9]*$/.test(v) || 'Numeric values only',
        v => (v).length === 22 || 'Numbers must be 22 digits',
      ],
      shipments: [],
    }),

    computed: {
      // validtrackingnumber () {
      //   let valid = false
      //   // all numeric
      //   if (this.package_tracking_number) {
      //     let pattern = /^[0-9]*$/
      //     if (pattern.test(this.package_tracking_number)) {
      //       if (this.package_tracking_number.length === 22) {
      //         valid = true
      //       }
      //     }
      //   }
      //   return valid
      // },
      getpostaldeposits () {
        let securitybags = this.$store.getters.getLoadedPostalDeposits.filter(deposit => deposit.shipped !== true)
        this.selected = securitybags
        return securitybags
      },
      displayShipmentDetail () {
        if (this.packagedetail) {

        }
      },
      shipmentDetail () {
        let detail = ''
        detail = this.$store.getters.getShipmentDetail
        console.log('shipment detail ', detail)
        let checkin_detail = ''
        checkin_detail = this.$store.getters.getCheckedDetail
        if (!checkin_detail || !this.packagedetail) {
          return detail
        }
        if (checkin_detail.length > 0) {
          Object.assign(detail, { duplicated: true })
        } else {
          Object.assign(detail, { duplicated: false })
        }
        return detail
      },
      checkinDupDetail () {
        let checkin_detail = ''
        checkin_detail = this.$store.getters.getCheckedDetail
        return checkin_detail.length
      },
      checkinInstructions () {
        let message = null
        let checkin_detail = ''
        checkin_detail = this.$store.getters.getCheckedDetail
        console.log('is it a dup ?', checkin_detail)
        if (checkin_detail.length > 0) {
          return 'This package has been checked in ***' + checkin_detail.length + '*** times before.' + '\nPlease check it in again unless this is an error'
        }
        return 'Check in package for vault validation'
      }
    },
    watch: {
      loading (val) {
        if (!val) return

        setTimeout(() => (this.loading = false), 1000)
      }
    },

    created () {
      this.initialize()
      // expected and genreated by our system
      // this.$store.dispatch('clearShipmentDetail')
      this.$store.dispatch('loadallpackages')
      this.name = this.$store.getters.user.email
      // previously checked in packages
      this.$store.dispatch('clearShipmentDetail')
    },
    beforeDestroy () {
    },
    methods: {
      closealert () {
        this.snackbar = false
      },
      validate () {
        this.$refs.form.validate()
        console.log('valid is now ', this.valid, this.$refs.form.validate())
      },
      reset () {
        this.$refs.form.reset()
        this.$refs.form.resetValidation()
        this.package_tracking_number = ''
        this.packagedetail = ''
        this.$store.dispatch('clearShipmentDetail')
        this.$store.dispatch('clearCheckedDetail')
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
      CheckInPackage () {
        // this.$store.dispatch('checkPackageIn', this.shipmentDetail)
        console.log('adding v2 package check in')
        this.$store.dispatch('checkPackageIn_v2', this.shipmentDetail)

        this.alertmessage = 'Your package has been checked in'
        this.snackbar = true
        this.$refs.form.reset()
        this.$refs.form.resetValidation()
        this.package_tracking_number = ''
        this.packagedetail = ''
        this.$store.dispatch('clearShipmentDetail')
        this.$store.dispatch('clearCheckedDetail')
      },
      findpackage () {
        let packagedetails = []
        if (this.$refs.form.validate()) {
          this.$store.dispatch('loadShipmentDetail', this.package_tracking_number)
          this.$store.dispatch('loadCheckedDetail', this.package_tracking_number)
          packagedetails = this.$store.getters.getAllPackageTrackingNumbers
          this.packagedetail = packagedetails.find(entry => entry === this.package_tracking_number)
          if (!this.packagedetail) {
            this.alertmessage = 'Package Tracking Number is NOT expected, Please alert management of this delivery of an un-expected package'
            this.snackbar = true
          }
          return this.packagedetail
        }
      },
      initialize () {
      },

    },
  }
</script>
